import { render, staticRenderFns } from "./PendingComments.vue?vue&type=template&id=620867b8&scoped=true"
import script from "./PendingComments.vue?vue&type=script&lang=js"
export * from "./PendingComments.vue?vue&type=script&lang=js"
import style0 from "./PendingComments.vue?vue&type=style&index=0&id=620867b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620867b8",
  null
  
)

export default component.exports